import React, { Fragment, Component } from 'react'


// https://stackoverflow.com/questions/48966464/add-raw-html-with-script-inside-gatsby-react-page?noredirect=1&lq=1
// let script = `
// <script type='text/javascript' src='//www.opentable.de/widget/reservation/loader?rid=166788&type=standard&theme=wide&iframe=true&overlay=false&domain=de&lang=de-DE'></script>
// `


class Opentable extends Component {
    // https://github.com/gatsbyjs/gatsby/blob/master/packages/gatsby-plugin-twitter/src/gatsby-browser.js
    loadScript(src) {
        var tag = document.createElement('script');
        tag.async = false;
        tag.src = src;
        document.getElementsByClassName('opentable')[0].appendChild(tag);
    }

    componentDidMount() {
		this.loadScript("//www.opentable.de/widget/reservation/loader?rid=166788&type=standard&theme=wide&iframe=true&overlay=false&domain=de&lang=de-DE")

	}

    render() {
        return (
            <div className="opentable" />
        )
    }

};

export default Opentable


// WEBPACK FOOTER //
// ./src/components/opentable.js